export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_ERROR = 'AUTH_ERROR'
export const REFRESH_SUCCESS = 'REFRESH_SUCCESS'
export const UPDATE_CURRENT_USER = 'UPDATE_CURRENT_USER'
export const RESET_CURRENT_USER = 'RESET_CURRENT_USER'
